<div class="registration-container">
  <div class="form-section">
    <img src="assets/new-logo-2.png" alt="Bipperz logo" class="logo"/>

    <h2 class="welcome-title">{{ 'consent.title' | translate }}</h2>

    <div class="document-box">
      <div
        class="document-content"
        [innerHTML]="'policy.consent' | translate"
      ></div>
    </div>

    <form [formGroup]="form" class="consent-form-fields">
      <div class="policy-checkbox-wrapper">
        <label class="custom-checkbox consent-checkbox">
          <input type="checkbox" formControlName="privacy"/>
          <span class="checkbox-box">
            <span class="checkbox-tick"></span>
          </span>

          <span class="checkbox-label">
            {{ 'consent.share_profile_with_partner_companies' | translate }}
          </span>
        </label>
      </div>

      <div class="policy-checkbox-wrapper">
        <label class="custom-checkbox consent-checkbox">
          <input type="checkbox" formControlName="terms"/>
          <span class="checkbox-box">
            <span class="checkbox-tick"></span>
          </span>

          <span class="checkbox-label">
            {{ 'consent.processing_sensitive_personal_data' | translate }}
          </span>
        </label>
      </div>

      <div class="policy-checkbox-wrapper">
        <label class="custom-checkbox consent-checkbox">
          <input type="checkbox" formControlName="dataPrivacyConsent"/>
          <span class="checkbox-box">
            <span class="checkbox-tick"></span>
          </span>

          <span class="checkbox-label">
            {{ 'consent.use_video_recordings_for_recruitment' | translate }}
          </span>
        </label>
      </div>

      <div class="policy-checkbox-wrapper">
        <label class="custom-checkbox consent-checkbox">
          <input type="checkbox" formControlName="allConsents"/>
          <span class="checkbox-box">
            <span class="checkbox-tick"></span>
          </span>

          <span class="checkbox-label">
            {{ 'consent.agree_to_all_consents' | translate }}
          </span>
        </label>
      </div>

      <div class="actions">
        <button type="button" class="back-button" (click)="goBack()">
          {{ 'common.back' | translate }}
        </button>

        <app-button
          (click)="continue()"
          [isFullWidth]="false"
          [label]="'registration.continue' | translate"
          [size]="ButtonSize.LARGER"
          [state]="isFormValid ? ButtonState.REGULAR : ButtonState.DISABLED"
          [type]="ButtonType.PRIMARY"
        ></app-button>
      </div>
    </form>
  </div>
</div>
